import { Button, Typography } from "@bca/ui-library";
import React from "react";
import { useSelector } from "react-redux";

import { StoreType } from "../../../redux/store.types";

const TryBetaButton = ({ handleOpenModal }) => {
  const store = useSelector((state: StoreType) => ({
    isVendor: state.app.isVendor,
  }));

  if (!store.isVendor) return null;

  return (
    <>
      <Button
        display={["none", "inline-flex"]}
        variant="secondary"
        minWidth={["calc(100% - 70px)", 160, 200, 200]}
        paddingLeft={[8, 9]}
        paddingRight={[8, 9]}
        marginTop="16px"
        marginBottom="-400px"
        paddingBottom="0px"
        marginRight="65px"
        height="48px"
        padding="0"
        onClick={handleOpenModal}
      >
        <Typography fontSize="16px" color="primary-light-blue">
          Join Live Sale
        </Typography>
      </Button>
    </>
  );
};

export default TryBetaButton;
